import { zodResolver } from "@hookform/resolvers/zod";
import { update } from "ramda";
import { z } from "zod";
import { ClientInputSchema } from "../../../../generated/zodSchemas";
import { clientBaseUrlRegex } from "@/entities/client/lib/clientBaseUrlRegex";

export function getClientFormInfo({
  default_app_url,
}: {
  default_app_url: string;
}) {
  const defaultUrl = new URL(default_app_url);
  const startAdornment = defaultUrl.protocol + "//";
  const endAdornment =
    "." + update(0, "platform", defaultUrl.host.split(".")).join(".");
  return {
    baseUrl: {
      startAdornment,
      endAdornment,
    },
    resolver: zodResolver(
      ClientInputSchema().extend({
        keycloakGroupName: z.string().trim().min(1),
        usersLimit: z.preprocess(
          (v) =>
            v === "" || v === null || v === undefined ? undefined : Number(v),
          z
            .number({ error: () => "Expected a valid number" })
            .int()
            .nonnegative()
            .min(0)
            .max(2147483647),
        ),
        applicationBrandColor: z.string().regex(/^#[0-9a-f]{6}$/i),
        applicationBaseUrl: z
          .union([
            z.literal(default_app_url),
            z.preprocess(
              (v) =>
                typeof v === "string"
                  ? startAdornment + v.trim() + endAdornment
                  : v,
              z.string().trim().max(100),
            ),
          ])
          .refine(
            (v) => {
              return clientBaseUrlRegex.test(v) && new URL(v).origin === v;
            },
            {
              message: "Invalid URL",
            },
          ),
        entityNamePlural: z.string().trim().min(1).max(12),
        entityNameSingular: z.string().trim().min(1).max(12),
        insightPlaceholderSingular: z.string().trim().min(1).max(12),
        insightPlaceholderPlural: z.string().trim().min(1).max(12),
      }),
    ),
  };
}
